import React from 'react';
import Table from 'components/Table/index';
import { widthLabel } from 'utils/stringFormatter';

export default function GridHistoricoRelatorioRequerimento({ dadosGrid }) {
  const montarLinha = lista => {
    return lista?.map(item => {
      return {
        key: item?.id,
        dataMudancaStatus: item?.dataMudancaStatus,
        status: item?.status || '-',
        dataSaidaStatus: item?.dataSaidaStatus || '-',
        solicitacao: widthLabel(item?.solicitacao, 100) || '-',
        responsavel: widthLabel(item?.responsavel, 100) || '-',
        atendente: item?.atendente || '-',
        distribuicao: item?.distribuicao || '-',
        setorDestino: item?.setorDestino || '-',
        setorOrigem: item?.setorOrigem || '-',
        observacao: widthLabel(item?.observacao, 100) || '-',
      };
    });
  };

  const columns = [
    {
      title: 'Data de alteração',
      dataIndex: 'dataMudancaStatus',
      key: 'dataMudancaStatus',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
    },
    {
      title: 'Data de saída',
      key: 'dataSaidaStatus',
      dataIndex: 'dataSaidaStatus',
    },
    {
      title: 'Solicitação',
      dataIndex: 'solicitacao',
      key: 'solicitacao',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      key: 'responsavel',
    },
    {
      title: 'Atendente',
      key: 'atendente',
      dataIndex: 'atendente',
    },
    {
      title: 'Atribuição',
      dataIndex: 'distribuicao',
      key: 'distribuicao',
    },
    {
      title: 'Setor Origem',
      key: 'setorOrigem',
      dataIndex: 'setorOrigem',
    },
    {
      title: 'Setor Destino',
      key: 'setorDestino',
      dataIndex: 'setorDestino',
    },
    {
      title: 'Observação',
      key: 'observacao',
      dataIndex: 'observacao',
    },
  ];

  return <Table columns={columns} data={montarLinha(dadosGrid)} />;
}
